/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Topic_IronInputs */

const en_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iron`)
};

const es_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hierros`)
};

const de_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eisen`)
};

const zh_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`铁杆`)
};

const ar_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأيرون`)
};

const fr_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fers`)
};

const vi_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gậy sắt`)
};

const sw_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vijiti vya chuma`)
};

const th_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม้เหล็ก`)
};

const bs_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Željeza`)
};

const ja_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイアン`)
};

const ko_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아이언`)
};

const pt_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferros`)
};

const it_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferri`)
};

const sv_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Järn`)
};

const nl_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IJzers`)
};

const da_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jern`)
};

const nb_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jern`)
};

const fi_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raudat`)
};

const pl_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Żelaza`)
};

const ru_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Айроны`)
};

const tr_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demir sopalar`)
};

const hi_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयरन`)
};

const id_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iron`)
};

const ms_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besi`)
};

const cs_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Železa`)
};

const el_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σίδερα`)
};

const he_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ברזלים`)
};

const af_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yster`)
};

const hu_practice_topic_iron = /** @type {(inputs: Practice_Topic_IronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vasak`)
};

/**
* | output |
* | --- |
* | "Iron" |
*
* @param {Practice_Topic_IronInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const practice_topic_iron = /** @type {((inputs?: Practice_Topic_IronInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Topic_IronInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_practice_topic_iron(inputs)
	if (locale === "de") return de_practice_topic_iron(inputs)
	if (locale === "zh") return zh_practice_topic_iron(inputs)
	if (locale === "ar") return ar_practice_topic_iron(inputs)
	if (locale === "fr") return fr_practice_topic_iron(inputs)
	if (locale === "vi") return vi_practice_topic_iron(inputs)
	if (locale === "sw") return sw_practice_topic_iron(inputs)
	if (locale === "th") return th_practice_topic_iron(inputs)
	if (locale === "bs") return bs_practice_topic_iron(inputs)
	if (locale === "ja") return ja_practice_topic_iron(inputs)
	if (locale === "ko") return ko_practice_topic_iron(inputs)
	if (locale === "pt") return pt_practice_topic_iron(inputs)
	if (locale === "it") return it_practice_topic_iron(inputs)
	if (locale === "sv") return sv_practice_topic_iron(inputs)
	if (locale === "nl") return nl_practice_topic_iron(inputs)
	if (locale === "da") return da_practice_topic_iron(inputs)
	if (locale === "nb") return nb_practice_topic_iron(inputs)
	if (locale === "fi") return fi_practice_topic_iron(inputs)
	if (locale === "pl") return pl_practice_topic_iron(inputs)
	if (locale === "ru") return ru_practice_topic_iron(inputs)
	if (locale === "tr") return tr_practice_topic_iron(inputs)
	if (locale === "hi") return hi_practice_topic_iron(inputs)
	if (locale === "id") return id_practice_topic_iron(inputs)
	if (locale === "ms") return ms_practice_topic_iron(inputs)
	if (locale === "cs") return cs_practice_topic_iron(inputs)
	if (locale === "el") return el_practice_topic_iron(inputs)
	if (locale === "he") return he_practice_topic_iron(inputs)
	if (locale === "af") return af_practice_topic_iron(inputs)
	if (locale === "hu") return hu_practice_topic_iron(inputs)
	return en_practice_topic_iron(inputs)
});